import { Coordinates } from '../types/ContactDetail';

export class GeoPoint {
  private earthRadiusInKm = 6371;

  public calculateDistanceInKm(origin: Coordinates, destination: Coordinates): number {
    const { latitude: latFrom, longitude: lonFrom } = origin;
    const { latitude: latTo, longitude: lonTo } = destination;

    const latFromRad = this.deg2rad(latFrom);
    const lonFromRad = this.deg2rad(lonFrom);
    const latToRad = this.deg2rad(latTo);
    const lonToRad = this.deg2rad(lonTo);

    const dLat = latToRad - latFromRad;
    const dLon = lonToRad - lonFromRad;

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(latFromRad) * Math.cos(latToRad) * Math.sin(dLon / 2) * Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return this.round(this.earthRadiusInKm * c);
  }

  private deg2rad(deg: number): number {
    return deg * (Math.PI / 180);
  }

  private round(distanceInKm: number): number {
    return Math.round(distanceInKm * 100) / 100;
  }
}
